<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid" :disabled="readonly">
      <fieldset>

        <legend class="text-h6 text-sm-h5" style="font-weight: bold; text-align: center">
          Expérience professionnelle et de formation(s) pratique(s) 
            </legend>
            <v-row>
              <v-col class="legalSection" cols="12" md="6">
                <Attachment
                  ref="equivCurriculumPrp"
                  :minRequired="1"
                  file-prefix="form_equiv_curriculum_prp"
                  @completeEvent="saveNextAttachment"
                  @refreshEvent="validateForm(true)"
                ></Attachment>
              </v-col>
              <v-col class="legalSection" cols="12" md="6">
                <Attachment
                  ref="employeurPrp"
                  :minRequired="1"
                  file-prefix="form_equiv_attestation_employeur_prp"
                  @completeEvent="saveNextAttachment"
                  @refreshEvent="validateForm(true)"
                ></Attachment>
              </v-col>
              <v-col class="legalSection" cols="12" md="6">
                <Attachment
                  ref="equivalenceAttestationStagePrp"
                  :minRequired="1"
                  file-prefix="form_equiv_attestation_stage_prp"
                  @completeEvent="saveNextAttachment"
                  @refreshEvent="validateForm(true)"
                ></Attachment>
              </v-col>
            </v-row>

      </fieldset>

      <v-autocomplete
        v-model="demandeAdmission.jeConfirmeEtreALEmploiDe"
        :item-text="itemText"
        :item-value="itemValue"
        :items="getDemandeAdmissionJeConfirmeEtreALEmploiDe"
        :rules="rules.jeConfirmeEtreALEmploiDe"
        label="Je confirme que je suis à l’emploi de"
        required
        return-object
      ></v-autocomplete>

    </v-form>
    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid" color="secondary" @click="saveAndContinueLater()">Enregistrer
        et terminer plus tard
      </v-btn>
      <v-btn :disabled="!valid" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Attachment from "../attachments/Attachment";
import Loader from "../Loader"
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin"
import PageReadonlyFormulaireAdmissionMixin from "@/mixins/pageReadonlyFormulaireAdmissionMixin"
import AttachementFormulaireMixin from "@/mixins/attachementFormulaireMixin";

export default {
  mixins: [
    NavigationPageFormulaireMixin,
    PageReadonlyFormulaireAdmissionMixin,
    AttachementFormulaireMixin
  ],
  props: {
    routeName: {
      type: String,
      default: ''
    },
  },
  components: {
    Loader: Loader,
    Attachment: Attachment,
  },
  data () {
    return {
      messageSelector: "",
      overlay: false,
      valid: true,
      typeAutre: [],
      rules: {
        jeConfirmeEtreALEmploiDe: [(v) => !!v || "Une valeur doit être selectionnée"],
      }
    }
  },
  computed: {
    ...mapGetters({
      demandeAdmissionId: "DemandeAdmission/GET_DEMANDEADMISSIONID",
      demandeAdmission: "DemandeAdmission/GET_DEMANDEADMISSION",
      demandeAdmissionPpId: "DemandeAdmission/GET_CONTACTID",
      getDemandeAdmissionJeConfirmeEtreALEmploiDe: "Catalogue/getDemandeAdmissionJeConfirmeEtreALEmploiDe",
    }),
  },
  created () {
    this.fetchItems()
  },
  methods: {
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getDocumentsByContactId: "Documents/getDocumentsByContactId",
      updateDemandeAdmission: "DemandeAdmission/updateDemandeAdmission",
    }),
    async fetchItems () {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        // Catalogue DemandeAdmission JeConfirmeEtreALEmploiDe
        await this.getCatalogue(1564);

        if (this.demandeAdmissionPpId  && this.demandeAdmissionPpId !== "") {
          await this.getDocumentsByContactId(this.demandeAdmissionPpId);
        }

        // Liste les uploads de fichiers
        this.refsUpload = [
          () => this.$refs.employeurPrp,
          () => this.$refs.equivalenceAttestationStagePrp,
          () => this.$refs.equivCurriculumPrp,
        ];

        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    async save () {
      this.$refs.form.validate()
      if (this.valid) {
        this.messageSelector = "Creation"
        this.overlay = true

        if (this.demandeAdmissionId && this.demandeAdmissionId != "") {
          this.demandeAdmission.id = this.demandeAdmissionId;
          await this.updateDemandeAdmission(this.demandeAdmission);
        }

        this.saveAttachments("demandeAdmission", this.demandeAdmissionId, () => {
          this.overlay = false;
          this.redirect();
        });
      }
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item,
    validateForm(resetValidation = false) {
      this.valid = (this.$refs.form?.validate() || false);
      if (resetValidation) {
        this.$refs.form?.resetValidation();
      }
    },
  }
}
</script>

<style>
</style>